import React from "react";
import { useLenis } from "../hooks/useLenis";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import { Marquee, Services, WhyChooseUs, Areas, Testimonials, DownloadApp } from "../components/site/Sections";
import QuoteForm from "../components/site/QuoteForm";
import Footer from "../components/site/Footer";

export default function Landing() {
  useLenis();
  return (
    <div className="bg-sage" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <WhyChooseUs />
      <Areas />
      <Testimonials />
      <QuoteForm />
      <DownloadApp />
      <Footer />
    </div>
  );
}
